import { render, staticRenderFns } from "./ItemFilterCreationUserFilter.vue?vue&type=template&id=5f781bee&scoped=true"
import script from "./ItemFilterCreationUserFilter.vue?vue&type=script&lang=js"
export * from "./ItemFilterCreationUserFilter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f781bee",
  null
  
)

export default component.exports